import { generatePath, useHistory, useLocation } from 'react-router-dom';
import {
  withTypes,
  Field,
} from 'react-final-form';
import classNames from 'classnames';
import queryString from 'query-string';
import { t } from 'ttag';

import SendIcon from '@svg/send.svg';
import { dialogDetails, login } from '@urls';
import { useAppContext } from '@contexts/AppContext';
import { Product } from '@hook/useProductFavorite';
import { getShafaAbsoluteUrl } from '@utils/common';
import { required } from '@utils/validators';
import { Button } from '@ui/Button';
import { FormError } from '@ui/FormError';
import { Input } from '@ui/Input';
import { ProductFavoritesToggleContainer } from '@containers/ProductFavoritesToggle';
import { ProductDetailsCreateOrderButtonsContainer } from '@containers/ProductDetailsCreateOrderButtons';

import s from './ProductDetailsBottomBar.sss';

export interface FormData {
  body?: string,
}

interface Props {
  className?: string,
  isAuth?: boolean,
  threadId?: number,
  product: Product | null,
  canStartDialog?: boolean,
  onSendMessage: (formData: FormData) => void,
}

export const ProductDetailsBottomBar: React.FC<Props> = ({
  className,
  isAuth,
  threadId,
  product,
  canStartDialog,
  onSendMessage,
}) => {
  const history = useHistory();
  const location = useLocation();
  const { Form } = withTypes<FormData>();

  const { isOutlet } = useAppContext();

  const handleMessageFormClick = () => {
    if (!isAuth) {
      history.push({
        pathname: login,
        search: queryString.stringify({
          next: location.pathname,
        }),
      });
    }
  };

  let shafaDialogPath: string | null = null;

  let outletDialogPath: string | null = null;

  if (threadId) {
    shafaDialogPath = generatePath(dialogDetails, {
      threadId,
    });
  
    outletDialogPath = getShafaAbsoluteUrl(
      history.createHref({ pathname: shafaDialogPath }),
    );
  }

  return (
    <div className={classNames(s.root, className)}>
      {!!product && !isOutlet && (
        <ProductFavoritesToggleContainer
          product={product}
          type="ProductDetails"
        />
      )}

      <ProductDetailsCreateOrderButtonsContainer isInStickyBar={true} />

      {threadId && shafaDialogPath && outletDialogPath ? (
        <Button
          theme="secondary"
          to={isOutlet ? outletDialogPath : shafaDialogPath}
        >
          {t`Перейти до листування`}
        </Button>
      ) : (
        <Form
          onSubmit={onSendMessage}
          render={({ handleSubmit, submitting, submitError }) => (
            <form
              className={s.form}
              onSubmit={handleSubmit}
              onClick={handleMessageFormClick}
            >
              <Field
                name="body"
                validate={required}
              >
                {({ input, meta }) => (
                  <>
                    <Input
                      {...input}
                      inputClassName={s.input}
                      placeholder={t`Написати продавцю`}
                      disabled={!canStartDialog || submitting}
                      error={(meta.touched && meta.error) || meta.submitError}
                      value={input.value || ''}
                    />

                    {submitError && (
                      <FormError>
                        {submitError}
                      </FormError>
                    )}

                    <Button
                      className={s.submit}
                      theme="text"
                      type="submit"
                      disabled={!canStartDialog || submitting}
                    >
                      <SendIcon
                        className={classNames(s.icon, {
                          [s.iconThemeGreen]: !!input.value,
                        })}
                        width="24"
                        height="24"
                      />
                    </Button>
                  </>
                )}
              </Field>
            </form>
          )}
        />
      )}
    </div>
  );
};
